import React, { useEffect } from 'react';

interface AdBannerProps {
  slot: string;
}

declare global {
  interface Window {
    adsbygoogle?: any[];
  }
}

const AdBanner: React.FC<AdBannerProps> = ({ slot }) => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error('AdSense error', e);
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'block', width: 200, height: 150 }}
      data-ad-client="ca-pub-3704036424102976"
      data-ad-slot={slot}
      data-ad-format="rectangle"
    />
  );
};

export default AdBanner;
